var map = {
	"./de.json": 653433,
	"./en.json": 652034,
	"./es.json": 763718,
	"./fr.json": 454033,
	"./it.json": 276171,
	"./ja.json": 384361,
	"./ko.json": 215710,
	"./pl.json": 440117,
	"./pt.json": 570071,
	"./ru.json": 713272,
	"./uk.json": 219234
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 978595;